var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { getFieldTitle } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import styled, { FontWeights } from "@rentiohq/web-theme";
import { rem } from "polished";
var Label = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: ", ";\n  color: ", ";\n  font-size: ", ";\n"], ["\n  font-weight: ", ";\n  color: ", ";\n  font-size: ", ";\n"])), FontWeights.SemiBold, function (props) { return props.theme.getColor("gray", 600); }, function (props) { return rem("14px", props.theme.baseFontSize); });
export var LabelField = function (props) {
    var uiSchema = props.uiSchema, _a = props.formContext, formContext = _a === void 0 ? {} : _a;
    var title = getFieldTitle(uiSchema, formContext);
    return _jsx(Label, { children: title });
};
var templateObject_1;
